<template>
  <van-collapse-item
    @click.stop.native="jump(item)"
    :disabled="!item.children"
    :is-link="(item.children && item.children.length !== 0) || false">
    <template #title>
      <div
        @click.stop="jump(item, true)"
        style="display: inline-block; cursor: pointer">
        {{ item.label }}
      </div>
    </template>
    <div
      class="collapse"
      v-if="item.children?.length">
      <nav-bar-menu-item
        v-for="(child, i) in item.children"
        :index="index"
        :i="i"
        :border="i !== 0"
        :item="child"
        :key="child.id"></nav-bar-menu-item>
    </div>
  </van-collapse-item>
</template>

<script>
import { geMenuDetailsInfo } from '@/api/index';
import { toPage } from '@/utils/tool';
export default {
  name: 'NavBarMenuItem',
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    i: {
      type: Number,
      default: 0,
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      toPage,
    };
  },
  methods: {
    jump(routeItem, father) {
      if (!routeItem.routingPath) return
      if (!routeItem.children?.length) {
        localStorage.setItem('menuId', routeItem.id);
        this.$bus.$emit('menuClose');
        this.tapSubmenuClic(routeItem, this.i, this.index);
      } else if (father) {
        localStorage.setItem('menuId', routeItem.id);
        this.$bus.$emit('menuClose');
        this.tapSubmenuClic(routeItem, this.i, this.index);
      }
    },
    tapSubmenuClic(item, index, host) {
      this.$store.state.enterp_somFlg = item.idNum;
      this.tempName = item.name;
      let id = this.getID(item.name, this.$store.state.treeList)?.id;

      if (host == 3) {
        this.$router.push({
          name: item.routingPath,
          query: { id: item.id },
          params: { flgId: index + 1, id: item.id },
        });
      } else if (host == 4) {
        if (item) {
          localStorage.setItem('typeId', item.id);
          localStorage.setItem('type', item.tableName);
        }
        this.$router.push({
          name: item.routingPath,
          query: { id: item.id },
        });
      } else if (host == 5) {
        if (this.getID(item.name, this.$store.state.treeList)?.id == 36) {
          geMenuDetailsInfo(
            this.getID(item.name, this.$store.state.treeList)?.id
          ).then((res) => {
            console.log(res);
            if (res.data) {
              this.$router.push({
                name: item.routingPath,
                params: { txt: res.data.data },
              });
            }
          });
        } else {
          this.$router.push({
            name: item.routingPath,
            params: {},
          });
        }
      } else {
        this.$router.push({
          name: item.routingPath,
          params: { id: id },
        });
      }

      this.$store.state.tapList.forEach((element, elementindex) => {
        if (elementindex == host) {
          element.underlineFlag = true;
          element.children?.forEach((children, childrenindex) => {
            if (childrenindex == index) {
              children.underlineFlag = true;
              // console.log(children.name, "撒地方撒1");
            } else {
              children.underlineFlag = false;
            }
          });
        } else {
          element.underlineFlag = false;
          if (element.children) {
            element.children?.forEach((children, childrenindex) => {
              children.underlineFlag = false;
              // console.log(children.name,children.underlineFlag, "撒地方撒");
            });
          }
        }
      });
      // console.log(this.$store.state.tapList, "撒旦法");
    },
    tapClic(item, index) {
      let id = '';
      this.$store.state.enterp_somFlg = item.idNum;
      if (item.idNum != 99) {
        id = this.getID(item.name, this.$store.state.treeList).id;
        this.shopNavFlg = item.idNum;
      }
      this.$router.push({
        name: item.url,
        params: { id: id },
      });
      this.$store.state.tapList.forEach((element, elementindex) => {
        if (elementindex == index) {
          element.navColFlg = element.idNum;
          element.underlineFlag = true;
        } else {
          element.navColFlg = '';
          element.underlineFlag = false;
        }
        if (element.children && element.children.length > 0) {
          element.children.forEach((children, childrenindex) => {
            children.underlineFlag = false;
            if (children.children && children.children.length > 0) {
              children.children.forEach((children, childrenindex) => {
                children.underlineFlag = false;
              });
            }
          });
        }
      });
    },
    // 回调函数
    getID(name, list) {
      let _this = this;
      for (let item of list || []) {
        if (item.label == name) return item;
        const sum = _this.getID(name, item.children);
        if (sum) return sum;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.collapse {
  padding: 0 0 0 20px;

  .van-collapse-item:nth-of-type(1) {
    &::after {
      border: none !important;
    }
  }

  &-item__wrapper {
    font-size: --van-cell-font-size;
    padding: var(--van-cell-vertical-padding) var(--van-cell-horizontal-padding);
  }
}
</style>
